import * as React from 'react';
import { VER_NUM } from '../../config/version';
import './Footer.css';

const Footer = props => {
    return (
        <footer className={`app-footer ${props.sidebarVisible ? '' : 'expand'}`}>
            <div className={`shrinkText ${props.sidebarVisible ? 'shrinkTextSidebarVisible' : ''}`}>
                <a href="https://www.postbank.bg/" target="blank">Postbank Roboadvisor&nbsp;</a>
                <span>&copy; 2022 Postbank Roboadvisor.</span>&nbsp;
            </div>
            <div className={`shrinkText ${props.sidebarVisible ? 'shrinkTextSidebarVisible' : ''}`}>
                {VER_NUM.length === 0 ? null : <span className="ver_num">Ver. # {VER_NUM}</span>}
            </div>
        </footer>
    );
};

export default Footer;
